import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import useBuildUpdateGlobalPaymentsRows from './buildUpdateGlobalPaymentsRows.helper';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateGlobalPaymentsProps = {
  onSubmit: (params: vp.SetGlobalPayCredentialsRequest) => void;
  onBack: () => void;
  defaultValues: vp.SetGlobalPayCredentialsRequest;
};
type FC = FunctionComponent<UpdateGlobalPaymentsProps>;

const UpdateGlobalPaymentsReview: FC = (props: UpdateGlobalPaymentsProps) => {
  const { onSubmit, defaultValues, onBack } = props;
  const updateGlobalPaymentsRows = useBuildUpdateGlobalPaymentsRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.GlobalPayments.Review' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  return (
    <Formik enableReinitialize initialValues={defaultValues} onSubmit={onSubmit} validateOnChange validateOnBlur>
      {({ values, handleSubmit }) => {
        const updateGlobalPaymentsTable: vp.TableProps = {
          name: 'update-global-payments-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updateGlobalPaymentsRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="background"
                onBlur={() => {}}
                onChange={() => {}}
                value={values[id]}
                disabled
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box flx="col" mb="lg" gapSize="16px">
              <UtilButton iconLeft="chevron_left" size="large" onClick={onBack}>
                {tGlobal('Buttons.back')}
              </UtilButton>
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updateGlobalPaymentsTable} />
            <Box width="100%" jc="fe" mt="md">
              <Button id="global-payments-submit" type="submit" label={tGlobal('Buttons.save')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default UpdateGlobalPaymentsReview;
